export const getRequestContentType = (data) => {
  if (data == null) {
    return undefined;
  }

  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    return undefined;
  }

  return 'application/json; charset=utf-8';
}
